export function orderType(status) {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = '等待支付';
      break;
    case 5:
      statusText = '已关闭';
      break;
    case 4:
      statusText = '已关闭';
      break;
    default:
      statusText = '已完成';
      break;
  }
  return statusText;
}// 订单状态
// 订单支付类型
export function paymentType(status) {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = '支付宝支付';
      break;
    case 2:
      statusText = '微信支付';
      break;
    // case 3:
    //   statusText = '余额';
    //   break;
    // case 4:
    //   statusText = '组合';
    //   break;
    // case 5:
    //   statusText = '加盟商余额';
    //   break;
    case 6:
      statusText = '花呗支付';
      break;
    // case 7:
    //   statusText = '非平台';
    //   break;
    case 9:
      statusText = '白条分期';
      break;
    default:
  }
  return statusText;
}

export function selectPayText(data) {
  let text = '';
  switch (data) {
    case 3:
      text = '实付';
      break;
    default:
      text = '应付';
  }
  return text;
}
